import React, { useState } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Trust } from './components/Trust';
import { TargetAudience } from './components/TargetAudience';
import { Outcomes } from './components/Outcomes';
import { Problem } from './components/Problem';
import { Features } from './components/Features';
import { Courses } from './components/Courses';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { LoginModal } from './components/LoginModal';

const App: React.FC = () => {
  const [isLoginOpen, setIsLoginOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white font-sans text-slate-900 antialiased">
      <Navbar onLoginClick={() => setIsLoginOpen(true)} />
      <main>
        <Hero />
        <Trust />
        <TargetAudience />
        <Problem />
        <Outcomes />
        <Courses />
        <Features />
        <FAQ />
        <div id="pricing">
          <Pricing />
        </div>
      </main>
      <Footer />
      <LoginModal isOpen={isLoginOpen} onClose={() => setIsLoginOpen(false)} />
    </div>
  );
};

export default App;